import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { UserGeneralDetails } from "../../../types/chat-support/chat-support.type";

type Props = {
  user: UserGeneralDetails;
  children: ReactNode;
  clickable?: boolean;
};

export const UserCardWithImageAndName = ({ user, children, clickable = false }: Props) => {
  const navigate = useNavigate();

  const handleUserClick = () => {
    navigate(`/users/${user.userId}`);
  };

  console.log(user);
  return (
    <div className=" flex gap-2   items-center ">
      <img 
        className={` size-[40px] rounded-full ${clickable ? 'cursor-pointer hover:opacity-80 transition-opacity' : ''}`}
        src={user.pictureURL} 
        alt="profile_Image" 
        onClick={clickable ? handleUserClick : undefined}
        title={clickable ? "Click to view user details" : undefined}
      />
      <div 
        className={`items-center ${clickable ? 'cursor-pointer hover:opacity-80 transition-opacity' : ''}`}
        onClick={clickable ? handleUserClick : undefined}
        title={clickable ? "Click to view user details" : undefined}
      >
        <p className=" font-bold   text-sm"> {user.name}</p>
        {children}
      </div>
    </div>
  );
};
